<template>
    <div :class="getFontClasses">

        <!-- EDIT MODE -->
        <markdown-editor v-if="editMode"
                         v-model="contentModel"
                         hint="Page contents"
        >
            <v-tooltip top color="primary">
                <template v-slot:activator="{ on }">
                    <span v-on="on">
                        <vue-markdown :class="'markdown-editor ' + getFontClasses(backgroundColor)"
                                      :source="data.content"
                                      :linkify="false"
                                      :html="false"
                                      :show="true">
                        </vue-markdown>
                    </span>
                </template>

                <span>Click to edit</span>
            </v-tooltip>
        </markdown-editor>

        <!-- RENDER MODE -->
        <div v-if="!editMode">

            <vue-markdown :class="'markdown-editor min-height ' + getFontClasses(backgroundColor)"
                          :source="content"
                          :linkify="false"
                          :html="false"
                          :show="true">
            </vue-markdown>

        </div>
    </div>
</template>

<script>

import VueMarkdown from '@adapttive/vue-markdown';
import TextEditor from "../TextEditor";
import MarkdownEditor from "../MarkdownEditor";
import colorMixin from "../DynamicProflingQuestions/colorMixin";

export default {

    mixins: [colorMixin],

    components: {
        TextEditor,
        MarkdownEditor,
        VueMarkdown
    },

    props: {
        editMode: {
            type: Boolean,
            required: false,
            default: false,
        },
        content: {
            type: String,
            required: true,
        },
        backgroundColor: {
            type: String,
            required: true,
        }
    },

    data() {
        return {
            data: {
                content: '',
            }
        }
    },

    watch: {
        content(value) {
            this.data.content = value;
        }
    },

    computed: {

        contentModel: {
            get() {
                return this.data.content;
            },
            set(value) {
                this.data.content = value;
                this.emitObject();
            }
        },

        fontClass() {
            return this.getFontClasses(this.backgroundColor);
        },
    },

    methods: {
        emitObject() {
            this.$emit('change:translations', this.data);
        }
    },

    mounted() {
        this.data.content = this.content;
    }
}
</script>

<style scoped>

    .min-height {
        min-height: 100px;
    }
</style>
